import { ArrowDownLeft, ArrowLeftRight, ArrowUpRight, RotateCcw } from "lucide-react";

import { formatMinor } from "../lib/money";
import type { AccountBalance, LedgerTransaction } from "../lib/types";

interface TransactionRowProps {
  transaction: LedgerTransaction;
  accounts: AccountBalance[];
  asButton?: boolean;
  active?: boolean;
  onClick?: () => void;
}

export function TransactionRow({ transaction, accounts, asButton, active, onClick }: TransactionRowProps) {
  const Icon = transaction.type === "expense" ? ArrowUpRight : transaction.type === "income" ? ArrowDownLeft : transaction.type === "refund" ? RotateCcw : ArrowLeftRight;
  const title = transaction.description || transaction.counterparty || typeLabel(transaction.type);
  const accountMap = new Map(accounts.map((account) => [account.accountId, account.name]));
  const negative = transaction.entries.find((entry) => entry.amountMinor < 0n);
  const positive = transaction.entries.find((entry) => entry.amountMinor > 0n);
  const meta = transaction.type === "transfer"
    ? `${accountMap.get(negative?.accountId ?? "") ?? "—"} → ${accountMap.get(positive?.accountId ?? "") ?? "—"}`
    : accountMap.get((negative ?? positive)?.accountId ?? "") ?? "—";
  const amount = transaction.type === "expense"
    ? -transaction.amountMinor
    : transaction.type === "income" || transaction.type === "refund"
      ? transaction.amountMinor
      : transaction.amountMinor;
  const className = asButton ? `history-item ${active ? "is-active" : ""}` : "transaction-row";
  const content = (
    <>
      <span className="transaction-icon"><Icon size={18} /></span>
      <span className="transaction-copy"><strong>{title}</strong><span>{transaction.occurredOn} · {meta}{transaction.deletedAt ? " · в корзине" : ""}</span></span>
      <strong className={`transaction-amount ${transaction.type}`}>{formatMinor(amount, transaction.type === "income" || transaction.type === "refund")}</strong>
    </>
  );
  return asButton ? <button type="button" className={className} onClick={onClick}>{content}</button> : <div className={className}>{content}</div>;
}

export function typeLabel(type: LedgerTransaction["type"]): string {
  return ({
    expense: "Расход",
    income: "Доход",
    transfer: "Перевод",
    opening_balance: "Начальный остаток",
    balance_adjustment: "Корректировка",
    refund: "Возврат",
  } as const)[type];
}
